import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// const firebaseConfig1 = {
//   apiKey: "AIzaSyDotg75gVVUlh1vkEjJdjafCKX5ZbIpWh8",
//   authDomain: "earning-e30c3.firebaseapp.com",
//   projectId: "earning-e30c3",
//   storageBucket: "earning-e30c3.firebasestorage.app",
//   messagingSenderId: "135569895532",
//   appId: "1:135569895532:web:94030cc212f39c0c5da849",
//   measurementId: "G-7XMJF1YMH1"
// };
const firebaseConfig1 = {

  apiKey: "AIzaSyAsEZY8t0tFicArLQuvYi4BMjTohBQ7cXA",

  authDomain: "media-89d91.firebaseapp.com",

  projectId: "media-89d91",

  storageBucket: "media-89d91.firebasestorage.app",

  messagingSenderId: "683100176166",

  appId: "1:683100176166:web:63231552c4895d5c358be7"

};

const firebaseConfig2 = {
  apiKey: "AIzaSyCFs38mh7OzribWzPCtmIRVDRcft-G2nZM",
  authDomain: "learning-396e2.firebaseapp.com",
  projectId: "learning-396e2",
  storageBucket: "learning-396e2.firebasestorage.app",
  messagingSenderId: "611887247397",
  appId: "1:611887247397:web:ed5f9d5e7183ad6ac94fcc",
  measurementId: "G-Y3CQ8Q3S9B"
};

// Initialize Firebase apps with explicit names
const app1 = getApps().some(app => app.name === 'app1') 
  ? getApp('app1') 
  : initializeApp(firebaseConfig1, 'app1');

const app2 = getApps().some(app => app.name === 'app2') 
  ? getApp('app2') 
  : initializeApp(firebaseConfig2, 'app2');

// Initialize Firebase services
export const auth1 = getAuth(app1);
export const db1 = getFirestore(app1);
export const storage1 = getStorage(app1);

export const auth2 = getAuth(app2);
export const db2 = getFirestore(app2);
export const storage2 = getStorage(app2);

export const COLLECTIONS = {
  BLOG_POSTS: 'blog_posts',
  BLOG_VIEWS: 'blog_views',
  BLOG_TOKENS: 'blog_tokens'
};
